import { get } from "lodash";

import { IChartProps } from "./Chart";
import BasicPieChart from "./BasicPieChart";

import { getBasicDataset, getPieTotal } from "../utils/option_main";
import { ChartType } from "../types/global-type";
import { IChartFormValue } from "../types/form-type";
import { ITableData, IWrokspaceData } from "../types/table-type";
import CalculationDataByChart from "./CalculationDataByChart";

import { RING_PIE_SMALL_CIRCLE_RADIUS } from "../constants/chart";

class PieRingChart extends BasicPieChart {
  private total: number;
  constructor(props: IChartProps) {
    super(props);
    this.total = 0;
  }

  public getDataset(
    formValue: IChartFormValue,
    tableData: ITableData,
    workspaceData: IWrokspaceData,
    calculation: CalculationDataByChart
  ) {
    const result = getBasicDataset(formValue, tableData, workspaceData, ChartType.PIE_RING, this.calculation);
    this.total = getPieTotal(result);
    const text = this.formatValue(this.total);
    this.centerValue = text;
    const sortTransForm = this.getPieSortTransform(get(result, "[0].dimensions[1]"));
    result.push(sortTransForm);
    return result;
  }

  public getSeries(formValue: IChartFormValue, tableData: ITableData, workspaceData: IWrokspaceData) {
    const basicConfig = this.getBasicPieSeries(formValue);
    const series = [
      {
        ...basicConfig,
        radius: [basicConfig.radius * RING_PIE_SMALL_CIRCLE_RADIUS, basicConfig.radius],
        itemStyle: {
          ...basicConfig.itemStyle,
          borderRadius: 3,
        },
        animationEasing: "cubicOut",
        animationEasingUpdate: "cubicOut",
      },
    ];
    this.setInnerCircleGeometricProperties(basicConfig.center, basicConfig.radius * 0.5);
    return series;
  }

  public setInnerCircleGeometricProperties(center: [number, number], radius: number) {
    this.innerCircleGeometricProperties = { center, radius };
  }
}

export default PieRingChart;
